import { Locale } from '@ps-smart-cp/ppfw-client';

const outputFileFormatNameConfig = {
  csv: new Map([
    [Locale.ja, 'CSV'],
    [Locale.en, 'CSV'],
  ]),
  csvForFileImport: new Map([
    [Locale.ja, 'CSV(データ取込用)'],
    [Locale.en, 'CSV For Data Import'],
  ]),
} satisfies Record<string, Map<Locale, string>>;

export { outputFileFormatNameConfig };
